export const LOADING_DONE = 'LOADING_DONE'
export const GET_REALTIES = 'GET_REALTIES'
export const GET_SOLD_AMOUNT = 'GET_SOLD_AMOUNT'
export const GET_FB_POSTS = 'GET_FB_POSTS'
export const CHECK_AUTH = 'CHECK_AUTH'
export const UPDATE_DATA = 'UPDATE_DATA'
